import React from 'react';
import { FormatToShortPriceTemplate } from '../../../../../utils/FormatValue';
import { getCurrentMonthYear } from '../../../../../utils/MonthYear/monthYear';

interface Props {
  materialsDataAsDictionary: Record<string, { totalValue: number; exposureCalendar: Record<string, number> }>;
  itemNames: Record<string, { name: string }>;
  colorsMap: Record<string, string>;
}

export const FutureOrdersSummaryLegend: React.FC<Props> = ({ materialsDataAsDictionary, itemNames, colorsMap }) => {
  const getMaterialExposure = (materialId: string): number => {
    const currentMonthYear = getCurrentMonthYear();
    const monthYearString = `${currentMonthYear.year}${currentMonthYear.month}`;
    return (
      materialsDataAsDictionary[materialId].exposureCalendar?.[monthYearString] ||
      materialsDataAsDictionary[materialId].totalValue ||
      0
    );
  };

  return (
    <div className="flex-1 space-y-3">
      {Object.keys(materialsDataAsDictionary).map((key) => (
        <LegendSingleLine
          amount={FormatToShortPriceTemplate(getMaterialExposure(key), '')}
          color={colorsMap[key]}
          key={key}
          title={itemNames[key].name}
        />
      ))}
    </div>
  );
};

interface LegendSingleLineProps {
  color: string;
  title: string;
  amount: string;
}

const LegendSingleLine: React.FC<LegendSingleLineProps> = ({ amount, color: backgroundColor, title }) => (
  <div className="flex space-x-2 justify-start">
    <div className="h-[10px] w-[10px] rounded-sm my-auto" style={{ backgroundColor }}></div>
    <div className="text-sm overflow-hidden max-w-36 flex-1 text-nowrap">{title}</div>
    <div className="text-sm font-bold ml-auto">{amount}</div>
  </div>
);
